export default "__VITE_ASSET__DDY$USsb__"